import { render, staticRenderFns } from "./JobSearchBox.vue?vue&type=template&id=b72f96ce&scoped=true"
import script from "./JobSearchBox.vue?vue&type=script&lang=js"
export * from "./JobSearchBox.vue?vue&type=script&lang=js"
import style0 from "./JobSearchBox.vue?vue&type=style&index=0&id=b72f96ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72f96ce",
  null
  
)

export default component.exports